import apiWrapper from '@/utils/apiHelpers/apiWrapper'
import { getPublications } from '@/utils/publications/helpers'
import { pageActions } from '@/store/page'
import headerHelper from '@/store/helpers/headerHelper'
import { generalConstants } from '@tweddle-se-team/common/constants'

const { DFOM } = generalConstants

const serverSideDataSubaru = async (store, ctx, { filters, publications, isPreview = false }) => {
  const { brand, model, modelType, year, language } = filters
  // Subaru shows image model image in the header
  await headerHelper.setHeaderModel(store, { brand, model, modelType, year, language })
  store.dispatch(pageActions.SET_TITLE(`${year} ${model} ${modelType}`))

  // Returning hotspots for specific vehicle (we already know the year of the vehicle for Subaru)
  const digitalFirstOwnerManual = publications.items.find(pub => pub.publicationType === DFOM && !!pub.contents?.ditaId)
  let baseDFOMEngPublication = language === 'en' ? digitalFirstOwnerManual : null
  let hotspots = {}

  if (digitalFirstOwnerManual) {
    const hotspotFilters = { brand, model, modelType, year }
    const queryParams = { page: 0, limit: 0, filters: JSON.stringify(hotspotFilters) }
    if (!isPreview) {
      queryParams.isPublished = true
    }
    const { data } = await apiWrapper.get('hotspots', queryParams, apiWrapper.getHeaders(ctx))
    hotspots = data?.[0]

    // For preview mode, swap draftMapping into mapping
    if (isPreview && hotspots?.draftMapping) {
      hotspots = {
        ...hotspots,
        mapping: hotspots.draftMapping
      }
    }

    // We use English publication as reference for mapping the topcis to tags
    if (!baseDFOMEngPublication) {
      const result = await getPublications({ ...filters, language: 'en', publicationType: DFOM }, {}, ctx)
      baseDFOMEngPublication = result?.items?.[0]
    }
  }

  // Get vehicle data from Subaru API when no publications are found
  let vehicleData = null
  if (!publications.items.length) {
    try {
      vehicleData = await apiWrapper.get(
        `vehicles/subaru/model/${model}/modelType/${modelType}/year/${year}`,
        {},
        apiWrapper.getHeaders(ctx)
      )
    } catch (error) {
      console.error(`Error fetching vehicle data: ${error.message}`)
    }
  }

  return {
    props: {
      publications,
      hotspots,
      baseDFOMEngPublication,
      digitalFirstOwnerManual,
      vehicleData,
      ...(isPreview && { isPreviewMode: true })
    }
  }
}

export default serverSideDataSubaru
